import React, {useContext} from 'react'
import {PurchaseContext} from "../../../context/PurchaseContext";
import {Button} from "antd";

const DeleteTaxRow = ({rowIndex}) => {

    const {taxes, updateDeleteCount} = useContext(PurchaseContext)
    const [, setTaxList] = taxes
    const [, setDeleteCount] = updateDeleteCount


    const handleDeleteClick = () => {
        setDeleteCount(oldCount => oldCount + 1)
        setTaxList(oldList => [...oldList.slice(0, rowIndex), ...oldList.slice(rowIndex + 1)] )
    }

    return(
        <React.Fragment>
            <Button type={'link'} danger onClick={handleDeleteClick}>Sil</Button>
        </React.Fragment>
    )
}
export default DeleteTaxRow